import {
  ArrowCircleLeft,
  ArrowCircleRight,
  BusinessOutlined,
  CheckCircleOutline,
} from "@mui/icons-material"
import { FC } from "react"
import { OrderStatusEnum } from "src/features/shared-module/constants"

interface OrderStatusIconProps {
  status: OrderStatusEnum
}

const iconSx = {
  fontSize: 20,
  "& path": {
    transform: "scale(1.2)",
    transformOrigin: "center",
  },
}

export const OrderStatusIcon: FC<OrderStatusIconProps> = ({ status }) => {
  switch (status) {
    case OrderStatusEnum.READY_FOR_HAULAGE:
      return (
        <BusinessOutlined
          sx={{
            ...iconSx,
            color: "#1A2A35",
          }}
        />
      )
    case OrderStatusEnum.ON_THE_WAY_TO_CUSTOMER:
      return (
        <ArrowCircleRight
          sx={{
            ...iconSx,
            color: "#0B7285",
          }}
        />
      )
    case OrderStatusEnum.ON_THE_WAY_TO_PROVIDER:
      return (
        <ArrowCircleLeft
          sx={{
            ...iconSx,
            color: "#F08C6A",
          }}
        />
      )
    case OrderStatusEnum.COMPLETED:
      return (
        <CheckCircleOutline
          sx={{
            ...iconSx,
            color: "#43A047",
          }}
        />
      )
    default:
      return null
  }
}
